export default "__VITE_ASSET__DNtjcBxf__";